if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.loading = false;
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      async loadMore() {
        const nextUrl = this.dataset.nextUrl;
        if (this.loading || !nextUrl) return;
        this.loading = true;
        this.classList.add('is-loading');

        try {
          const url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString());
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const grid = document.getElementById('product-grid');
          const newItems = html.querySelectorAll('#product-grid > .grid__item');

          newItems.forEach((item) => {
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            grid.appendChild(document.importNode(item, true));
          });

          const nextLoader = html.querySelector('infinite-scroll');
          if (nextLoader && nextLoader.dataset.nextUrl) {
            this.dataset.nextUrl = nextLoader.dataset.nextUrl;
            this.loading = false;
            this.classList.remove('is-loading');
            const rect = this.getBoundingClientRect();
            if (rect.top < window.innerHeight + 600) this.loadMore();
          } else {
            this.remove();
          }
        } catch (error) {
          this.loading = false;
          this.classList.remove('is-loading');
        }
      }
    }
  );
}
